import React from 'react';
import './ndoeUi.css';

/**
 * NdoeToolbar — barre d'outils (recherche à gauche, actions à droite).
 * Flex-wrap : passe proprement en colonne sur mobile.
 *
 * Props :
 *  - search   : node (ex. <Input.Search/>) placé en zone flexible
 *  - children : actions / boutons additionnels
 *  - className
 */
export default function NdoeToolbar({ search, children, className = '' }) {
  return (
    <div className={`ndoe-toolbar ${className}`}>
      {search ? <div className="ndoe-toolbar__search">{search}</div> : <span className="ndoe-toolbar__spacer" />}
      {children}
    </div>
  );
}
